import { alpha, Theme } from '@rossum/ui/material';
import { gridClasses } from '@rossum/ui/x-data-grid-pro';

const {
  columnHeader,
  columnHeaders,
  cellCheckbox,
  columnHeaderCheckbox,
  cell,
  row,
} = gridClasses;

// sx Property in MUI:
// Utilizes the sx property for inline styles with access to the theme. Not only can you use theme values directly,
// but you can also define functions within sx for each attribute, allowing dynamic styling based on the theme.
// For example, you can set colors dynamically like this:

// <Box sx={{ color: theme => theme.palette.primary.main }}>Dynamic primary color</Box>

// This means for each style attribute in sx, you can use a callable function that receives the theme,
// offering dynamic access to any theme value.
// More info: https://mui.com/material-ui/customization/how-to-customize/#the-sx-prop

export const tableSxStyles = {
  borderColor: 'transparent',
  '&': {
    [`.${columnHeader}:focus, .${cell}:focus, .${cellCheckbox}:focus-within, .${columnHeaderCheckbox}:focus-within`]:
      {
        outline: 'none',
      },
    [`& .${cell}, .${columnHeaders}`]: {
      borderColor: 'transparent',
    },
    [`& .${row}.odd, .${row}.even`]: {
      transition: 'background-color 0.15s',
    },
    [`& .${row}.odd`]: {
      '&:hover, &.Mui-hovered': {
        backgroundColor: (t: Theme) => alpha(t.palette.common.white, 0.1),
      },
    },
    [`& .${row}.even`]: {
      backgroundColor: (t: Theme) => alpha(t.palette.common.white, 0.05),
      '&:hover, &.Mui-hovered': {
        backgroundColor: (t: Theme) => alpha(t.palette.common.white, 0.1),
      },
    },
  },
};
